import * as React from 'react';
import { useParams } from 'react-router-dom';
import GenericEditor from './GenericEditor';
import { UserELPAdminFields } from '../editorFields/UserELPAdminFields';
import { UserELP, ValidationSchema } from '../../models/UserELP';
import UserELPService from '../../services/UserELPService';
import { AppUserFile, AppUserInfo, FileTypeToAppUserFile, SubmissionCycleSettingsToFileTypeExtensionDate } from '../../models';
import { useContext } from 'react';
import AuthenticationContext from '../context/AuthenticationContext';
import { AppUserFilesSearch } from '../views/AppUserFilesSearch';


export const ELPEditor = () => {

    let { id } = useParams();

    return <>
        <GenericEditor<UserELP, string>
            getById={id => UserELPService.getELP(id || '')}
            save={model => UserELPService.save(model)}
            formikFields={UserELPAdminFields}
            validationSchema={ValidationSchema}
            getId={x => x.userProfileId}
            stringToId={x => x}
            shouldTryToLoad={id => true}
            disableSaveButton={false}
            errorsMap={{

            }}
        />
    </>
}
